export default __webpack_public_path__ + "static/base-plus-5-caa56589fa6008d8d72834851cbb0688.jpg";